import React from 'react';
import {
  studentStatusType,
  studentType,
} from '../../../constants/types/student-type';
import TextWinds from '../../../components/common/TextWinds';
import StudentConroller from './StudentController';
import Buttons from '../../../components/common/Buttons2';
import {
  CheckBadgeIcon,
  TrashIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { UserMinusIcon, UserPlusIcon } from '@heroicons/react/20/solid';

interface StudentStateControlProps {
  status: studentStatusType;
  studentList: studentType[];
  reloadTable: () => void;
  controller: StudentConroller;
}
const StudentStateControl = ({
  status,
  studentList,
  controller,
}: StudentStateControlProps) => {
  return (
    <div>
      <div className="flex justify-end gap-x-[22px] py-2">
        <div className="flex items-center gap-x-3">
          <TextWinds type="content_body4" color="gray7" className="w-[68px]">
            {studentList.length}명 선택됨
          </TextWinds>
        </div>
        <div className="flex gap-x-2">
          {status === studentStatusType.ACTIVE && (
            <Buttons
              variant="outlined"
              color="red5"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.assignHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <UserGroupIcon className="mr-2 h-5 w-5 text-red-500" />
              선택 반 배정
            </Buttons>
          )}
          {status === studentStatusType.ACTIVE && (
            <Buttons
              variant="filled"
              color="orange4"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.stopHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <UserMinusIcon className="mr-2 h-5 w-5 text-white" />
              선택 정지
            </Buttons>
          )}
          {(status === studentStatusType.INACTIVE ||
            status === studentStatusType.PENDING) && (
            <Buttons
              variant="filled"
              color="purple5"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.registHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <CheckBadgeIcon className="mr-2 h-5 w-5 text-white" />
              선택 수강 등록
            </Buttons>
          )}
          {(status === studentStatusType.INACTIVE ||
            status === studentStatusType.PENDING) && (
            <Buttons
              variant="outlined"
              color="red5"
              type="secondary"
              className="whitespace-nowrap text-sm"
              onClick={() => controller.deleteHandler(studentList)}
              disabled={studentList.length === 0}
            >
              <TrashIcon className="mr-2 h-5 w-5 text-red-500" />
              선택 삭제
            </Buttons>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentStateControl;
